const zh = {
  language: {
    zh: '中文',
    en: 'English',
    id: 'Indonesia',
    th: 'ภาษาไทย'
  },
  dialog: {
    tips: '温馨提示',
    confirm: '确定',
    cancel: '取消',
  },
  error: {
    tips_1: '服务出小差啦',
    tips_2: '好像找不到资源了',
    tips_3: '操作失败，请联系商家',
  },
  bindings: {
    deviceBinding: '设备绑定',
    tips: '温馨提示',
    tipsContent: '输入设备号绑定设备，可随时查看流量使用情况',
    device: '设备号',
    deviceTips: '请输入设备号',
    searchHistory: '历史搜索记录',
    searches: '条',
    binding: '绑定',
    imeiTips: '请输入设备号'
  },
  xinXunIndex: {
    deviceManagement: '设备管理',
    onlineDevice: '在线设备',
    currentNetwork: '当前网络',
    signalStrength: '信号强度',
    online: '在线',
    offline: '离线',
    switchingDevices: '切换设备',
    daysRemaining: '剩余天数',
    usedData: '已用流量',
    toady: "今日用量",
    total: '总量',
    rechargeAndPay: '充值缴费',
    myPackage: '我的套餐',
    customerService: '客服服务',
    change: '修改名称、密码',
    hotspotName: '热点名称',
    password: 'WIFI密码',
    saveChanges: '保存修改',
    status: '状态',
    language: '语言',
    wifiName: '名称不能为空',
    wifiPassword: '密码不能为空',
    wifiTips: '修改成功后请重启设备，远程修改账号密码需等待3~5分钟，请耐心等待。',
  },
  usage: {
    myPackage: '我的套餐',
    currentPackage: '当前套餐',
    packageRenewalHistory: '历史续费套餐',
    rechargeAndPay: '充值缴费',
    effectiveDate: '生效日期',
    expirationDate: '失效日期',
    useData: '当前套餐已使用流量',
    orderNumber: '订单号',
    received: '已到账',
    processing: '未到账',
    unknown: '未知'
  },
  planList: {
    home: '首页',
    packageList: '套餐列表',
    monthlyAverage: '月均',
    validityPeriod: '有效期',
    days: '天',
    unlimited: '无限量',
    longTerm: '长期有效',
    tips_1: '此设备暂无充值套餐,请联系店铺客服',
    tips_2: '此设备暂无充值套餐，请联系客服人员及时处理',
    newUserOffer: '新人特惠'
  },
  packageDetails: {
    packageDetails: '套餐详情',
    data: '流量',
    packageDescription: '套餐说明',
    rechargeNow: '立即充值'
  },
  recharge: {
    payNow: '立即支付',
    unit: '¥',
    paymentMethod: '支付方式',
    onlinePayment: '在线支付',
    alipayPayment: '支付宝支付',
    weChatPayment: '微信支付',
    effectiveDate: '生效日期',
    activateNow: '立即生效',
    selectDate: '指定时间',
    createOrderTip: '创建订单中,请等候'
  },
  qrCode: {
    tips_1: '您需要授予相机访问权限',
    tips_2: '这个设备上没有摄像头',
    tips_3: '相机被占用',
    tips_4: '安装摄像头不合适',
    tips_5: '此浏览器不支持流API',
    tips_6: '所需的安全上下文(HTTPS、本地主机)',
  },
  toast: {
    loading: '加载中...'
  }
}
export default zh